'use client';

import React from 'react';
import { GraduationCap, Flame, Trophy } from 'lucide-react';

export default function LearningHeader() {
  return (
    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
      <div>
        <div className="flex items-center gap-2.5 mb-1">
          <div className="w-8 h-8 rounded-lg bg-primary/15 flex items-center justify-center">
            <GraduationCap size={18} className="text-primary" />
          </div>
          <h1 className="text-xl font-bold text-foreground tracking-tight">Learning Area</h1>
        </div>
        <p className="text-sm text-muted-foreground ml-10.5">
          Master trading fundamentals — track your progress across every module.
        </p>
      </div>

      <div className="flex items-center gap-3">
        <div className="flex items-center gap-2 bg-card border border-border rounded-lg px-3 py-2">
          <Flame size={15} className="text-warning" />
          <span className="text-xs font-semibold text-foreground">7-day streak</span>
        </div>
        <div className="flex items-center gap-2 bg-card border border-border rounded-lg px-3 py-2">
          <Trophy size={15} className="text-primary" />
          <span className="text-xs font-semibold text-foreground">4 / 12 completed</span>
        </div>
      </div>
    </div>
  );
}
